import { render, staticRenderFns } from "./base-performance-sub-detail.vue?vue&type=template&id=07a0e8b4&scoped=true"
import script from "./base-performance-sub-detail.vue?vue&type=script&lang=ts"
export * from "./base-performance-sub-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0e8b4",
  null
  
)

export default component.exports